import './fileToolbar.scss'
import React from 'react';
import { NavFileContainerRightSideType } from './fileToolbarTypes';
import { RightSideHistory } from './History/fileToolbarHistory';
import { ActivityCenter } from './ActivityCenter/activityCenterComponent';
import NoteRightSide from './Notes/fileToolbarNote';
import { ThirdPartyList } from '../Components/ThirdPartyList/ThirdPartyComponent';
import { MortgageLender } from '../Components/MortgageLender/MortgageLender';
import { RightSideKeyDates } from '../Components/taskSystem/KeyDates';
import { defaultMenuRight } from './fileToolbarConsts';
import { RightSideBar } from './fileToolbarMenuItem';
import { DocsDropbox } from '../Components/MortgageAnalyzer/DocsDropbox';
import { connect } from "react-redux";
import { lddStateObject } from '../redux/reducer';
import DisconnectModal from '../Components/BuilderConnect/BuilderConnectInfo/DisconnectModal';
import { LenderCentre } from '../Components/MortgageAnalyzer/LenderCentre';
import { AdsCarousel } from '../dr/Components/Ads/AdsCarousel';
import { isPageInDR } from '../dr/Components/drFuncs';
import { RenAIRightSide } from './RenAI/RenAIRightSide';
import { lddGlobalSessionInfo } from '../Components/navigationTypes';
import AddNewAppModal from '../Components/taskSystem/addNewApp';

interface NavFileContainerRightSideState {
    showAddAppModal: boolean;
    SESSION_INFO?: lddGlobalSessionInfo;
    livedataRootContainer?: lddStateObject['currentNavigation']['livedataRootContainer'];
}

class NavFileContainerRightSide extends React.Component<NavFileContainerRightSideType & { SESSION_INFO?: lddGlobalSessionInfo, livedataRootContainer?: lddStateObject['currentNavigation']['livedataRootContainer'] }, NavFileContainerRightSideState> {
    selectorRef: React.MutableRefObject<HTMLDivElement>;
    constructor(props: NavFileContainerRightSideType & { SESSION_INFO?: lddGlobalSessionInfo, livedataRootContainer?: lddStateObject['currentNavigation']['livedataRootContainer'] }) {
        super(props);
        this.selectorRef = React.createRef();
        this.state = {
            showAddAppModal: false
        };
    }

    handleAddAppointment = async (newAppointment: any) => {
        if (!this.props.SESSION_INFO) {
            console.error('SESSION_INFO not available');
            return;
        }

        try {
            const response = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${this.props.SESSION_INFO.appProvinceShort}/${this.props.SESSION_INFO.firm.id}/set/addappointment?SessionID=${this.props.SESSION_INFO.sid}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newAppointment)
            });

            const data = await response.json();
            
            if (!data.ok) {
                throw new Error(data.error || 'Failed to add appointment');
            }
        } catch (error) {
            console.error('Error adding appointment:', error);
            throw error;
        }
    };

    render(): React.ReactNode {
        return isPageInDR(this.props.page) ? (
            this.props.datarootContainer.dataRoot && (
                <div id="fileToolbar" className="toolbar-container">
                    <AdsCarousel />
                </div>
            )
        ) : (
            <div id="fileToolBar" className="toolbar-container">
                <RightSideHistory datarootContainer={this.props.datarootContainer} page={this.props.page} sidebarshow={this.props.sidebarshow} toggleState={this.props.toggleState} />
                <NoteRightSide datarootContainer={this.props.datarootContainer}
                    sidebarshow={this.props.sidebarshow}
                    toggleState={this.props.toggleState} />
                {
                    this.props.datarootContainer?.dataRoot && 
                    (
                        <RenAIRightSide
                            datarootContainer={this.props.datarootContainer}
                            page={this.props.page}
                            sidebarshow={this.props.sidebarshow}
                            toggleState={this.props.toggleState}
                        />
                    )
                }
                <RightSideKeyDates datarootContainer={this.props.datarootContainer} page={this.props.page} sidebarshow={this.props.sidebarshow} toggleState={this.props.toggleState} />
                <ActivityCenter
                    page={this.props.page}
                    sidebarshow={this.props.sidebarshow}
                    toggleState={this.props.toggleState} />
                <RightSideBar
                    link={defaultMenuRight[0].navigate}
                    label={defaultMenuRight[0].label}
                    toggle={this.props.toggle}
                    page={this.props.page}
                    onShowAddAppModal={() => this.setState({ showAddAppModal: true })}
                />

                <ThirdPartyList listName="LawyerList" />
                <ThirdPartyList listName="InsuranceList" />
                <ThirdPartyList listName="RealEstateBrokerList" />
                <ThirdPartyList listName="ConveyancerList" />
                <ThirdPartyList listName="MortgageBrokerList" />
                <ThirdPartyList listName="PurchaserRealEstateBrokerList" />
                <ThirdPartyList listName="OtherPartyList" />
                <MortgageLender />
                {
                    this.props.showDocsDropbox && 
                    <DocsDropbox 
                        fileLocation={this.props['fileLocation'] ?? '--ldd-default-renai-request'}
                    />
                }
                {this.props.showDRDisconnect && <DisconnectModal />}
                {this.props.showLenderCentre  && <LenderCentre />}
                {this.props.SESSION_INFO && (
                    <AddNewAppModal
                        showAddModal={this.state.showAddAppModal}
                        setShowAddModal={(show) => this.setState({ showAddAppModal: show })}
                        handleAddAppointment={this.handleAddAppointment}
                        livedataRootContainer={this.props.livedataRootContainer}
                        SESSION_INFO={this.props.SESSION_INFO}
                        isFromCalendar={false}
                    />
                )}
            </div>
        )
    }
}

const mapStateToProps = (state: lddStateObject) => {
    const { ThirdPartyListState } = state
    let ThirdPartyListExtraPayload = {};
    if (state.ThirdPartyListExtraPayload){
        ThirdPartyListExtraPayload = state.ThirdPartyListExtraPayload;
    }
    return { 
        showDocsDropbox: ThirdPartyListState === "showMortgageDropbox",
        showDRDisconnect: ThirdPartyListState === "showDRDisconnect",
        showLenderCentre: ThirdPartyListState === "showLenderCentre",
        UserID: state.SessionInfo?.firm?.id,
        SESSION_INFO: state.SessionInfo,
        livedataRootContainer: state.currentNavigation.livedataRootContainer,
        ...(ThirdPartyListState === "showMortgageDropbox" && ThirdPartyListExtraPayload && { fileLocation: ThirdPartyListExtraPayload['fileLocation'] })
    }
}

export default connect(mapStateToProps)(NavFileContainerRightSide) 